import { __rest } from '../../../_virtual/_tslib.js';
import React__default, { useRef, useState, useContext, useLayoutEffect, useCallback, useEffect } from 'react';
import { classNames } from '../../../helpers/classnames.js';
import { getBEMClasses } from '../../../helpers/get-bem.js';
import { PopupsContext } from '../../../helpers/popupsContext.js';
import { useDebounceCallback } from '../../../helpers/use-debounce-callback.js';

var _a = getBEMClasses('dsb__positioner'), positionerBlock = _a[0], positionerModifier = _a[1];
var defaultMinHeight = 88;
var Positioner = function (_a) {
    var _b;
    var children = _a.children, _c = _a.align, align = _c === void 0 ? 'center' : _c, positionerClassName = _a.positionerClassName, targetElement = _a.targetElement, _d = _a.verticalOffset, verticalOffset = _d === void 0 ? 0 : _d, _e = _a.horizontalOffset, horizontalOffset = _e === void 0 ? 0 : _e, _f = _a.applicationRootElementID, applicationRootElementID = _f === void 0 ? 'root' : _f, scrollable = _a.scrollable, _g = _a.minHeight, minHeight = _g === void 0 ? defaultMinHeight : _g;
    // попробую просто переписать? Буду исходить не от Рута а от window
    var positionerRef = useRef(null);
    var _h = useState(false), hasCalculatedStyle = _h[0], setCalculatedStyle = _h[1];
    var rootElementContext = useContext(PopupsContext).rootElement;
    var _j = useState(rootElementContext || document.getElementById(applicationRootElementID) || document.body), root = _j[0], setRoot = _j[1];
    // находим root
    useLayoutEffect(function () {
        var rootElement = rootElementContext || document.getElementById(applicationRootElementID);
        if (!rootElement) {
            throw new Error("Application root element with ID \"".concat(applicationRootElementID, "\" not found"));
        }
        setRoot(rootElement);
    }, [applicationRootElementID, rootElementContext]);
    // Считает и вызывает 
    function calculateAndUpdate() {
        var _a;
        var parentRect = (_a = targetElement === null || targetElement === void 0 ? void 0 : targetElement.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!positionerRef.current || !parentRect) {
            return;
        }
        var style = {};
        var contentOffsetHeight = positionerRef.current.offsetHeight + verticalOffset * 2;
        var bottomSpace = window.innerHeight - parentRect.bottom;
        var positionerRect = positionerRef.current.getBoundingClientRect();
        //Позиционируем по вертикали 
        if (bottomSpace > contentOffsetHeight) {
            style.top = parentRect.bottom + verticalOffset;
        }
        else {
            // Проверяем сверху
            if (parentRect.top > contentOffsetHeight) {
                style.bottom = window.innerHeight - parentRect.top + verticalOffset;
            }
            else {
                //проверяем, если сверху больше, то туда, иначе рисуем снизу ужимая
                if (parentRect.top > bottomSpace) {
                    //проверяем влезит ли вообще  куда-то, если нет, то просто по краю 
                    if (parentRect.top > minHeight + verticalOffset * 2) {
                        style.height = parentRect.top;
                        style.bottom = window.innerHeight - parentRect.top + verticalOffset;
                    }
                    else {
                        style.height = minHeight;
                        // считаем от верхнего края, так как если не влазит, будет заходить на элемент
                        style.top = verticalOffset;
                    }
                }
                else {
                    if (bottomSpace > minHeight + verticalOffset * 2) {
                        style.height = bottomSpace;
                        style.top = parentRect.bottom + verticalOffset;
                    }
                    else {
                        style.height = minHeight;
                        // считаем от верхнего края, так как если не влазит, будет заходить на элемент
                        style.bottom = verticalOffset;
                    }
                }
            }
        }
        //Позиционируем по горизонтали
        switch (align) {
            case 'center': {
                // Нужны ли здесь доп правила и урезания по ширине ? Ведь доп скролл точно не нужен...
                style.left = Math.min(parentRect.left + parentRect.width / 2 - positionerRect.width / 2, window.innerWidth - positionerRect.width - horizontalOffset);
                break;
            }
            case 'left': {
                style.left = Math.min(parentRect.left, window.innerWidth - positionerRect.width - horizontalOffset);
                break;
            }
            case 'right': {
                style.left = Math.max(parentRect.right - positionerRect.width, horizontalOffset);
                break;
            }
            default: {
                //Бусть по дефолту будет слева
                style.left = Math.min(parentRect.left, window.innerWidth - positionerRect.width - horizontalOffset);
                break;
            }
        }
        applyStyle(style);
    }
    //Применение стилей
    var applyStyle = useCallback(function (_a) {
        var position = _a.position, pixelValues = __rest(_a, ["position"]);
        if (!positionerRef.current) {
            return;
        }
        var positionString = position ? "position:".concat(position, ";") : '';
        var props = ['top', 'left', 'right', 'bottom', 'height'];
        var sideValuesString = props
            .map(function (key) {
            return pixelValues[key] !== undefined ? "".concat(key, ":").concat(pixelValues[key], "px;") : "".concat(key, ":auto;");
        })
            .join('');
        positionerRef.current.setAttribute('style', positionString + sideValuesString);
        if (!hasCalculatedStyle) {
            setCalculatedStyle(true);
        }
    }, []);
    var updatePosition = useCallback(function () {
        calculateAndUpdate();
    }, [align, horizontalOffset, minHeight, scrollable, targetElement, verticalOffset]);
    var debouncedUpdatePosition = useDebounceCallback(updatePosition, 50)[0];
    /**
     * слушает ресайз панели
     *
     * нужен чтобы пересчитать позицию при изменении размеров контента
     *
     * например при изменении кол-ва айтемов в списке панель должна уменьшиться
     * посути перекрывает кейсы, которые не закрывает слушатель мутации
     */
    // useEffect(() => {
    // 	const parentMutation = new MutationObserver(debouncedUpdatePosition);
    // 	parentMutation.observe(targetElement.current, { attributes: false, childList: true, subtree: true });
    // 	return () => {
    // 		parentMutation.disconnect();
    // 	};
    // }, [targetElement]);
    /**
     * слушает мутацию рута, обновляет позицию при изменении поддерева
     * например нужно обновить позицию если добавится новый элемент и он сместит targetElement
     *
     * будут и ложные срабатывания, но сильной нагрузки не произойдет т.к работает только при открытом Positioner + есть дебаунс
     */
    useEffect(function () {
        var parentMutation = new MutationObserver(debouncedUpdatePosition);
        parentMutation.observe(root, { attributes: false, childList: true, subtree: true });
        return function () {
            parentMutation.disconnect();
        };
    }, [root]);
    useEffect(function () {
        updatePosition();
        var disposables = [];
        var handleListener = function (element, type) {
            element.addEventListener(type, updatePosition);
            disposables.push(function () { return element.removeEventListener(type, updatePosition); });
        };
        handleListener(window, 'resize');
        handleListener(window, 'scroll');
        return function () {
            disposables.forEach(function (cleanup) { return cleanup(); });
        };
    }, []);
    var positionerClass = classNames(positionerBlock, (_b = {},
        _b[positionerModifier('calculating')] = !hasCalculatedStyle,
        _b), positionerClassName);
    return (React__default.createElement("div", { ref: positionerRef, className: positionerClass }, children));
};

export { Positioner };
